import { Button, Col, Row } from 'reactstrap'
import { primary_color } from '../../../Helper/uiHelper'
import { AvField, AvForm, AvRadio, AvRadioGroup } from 'availity-reactstrap-validation'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { request } from '../../../Redux/Sagas/requests/api'
import { clearCurrentRowData, clearParentTableData, fetchUpdateApiData } from '../../../Redux/Reducers/CMS'
import { isSuccessResponse } from '../../../helper'
import Loader from 'react-loaders'

const UpdateRenewalStudent = ({ addDataDetail, setAddGridDataDetail }) => {
  const [bookingData, setBookingData] = useState([])
  const [userData, setUserData] = useState({})
  const [submitting, setSubmitting] = useState(false)
  const dispatch = useDispatch()

  const currentRow = useSelector((state) => state.CMS.currentRow)
  const [loadingGrid, setLoadingGrid] = useState(() => !!currentRow?.[1])
  const [eligibleForRenewal, setEligibleForRenewal] = useState(currentRow?.[1]?.status === 0)

  useEffect(() => {
    if (!currentRow?.[1]) {
      setLoadingGrid(false)
      return
    }
    setLoadingGrid(true)
    request('renewal-tabs-grid', 'POST', { id: currentRow?.[1]?.id })
      .then((res) => {
        if (res?.data?.units) {
          setBookingData(res?.data?.units)
        }
        if (res?.data?.user) {
          setUserData(res?.data?.user)
        }
        if (res?.data?.user?.eligible_for_renewal !== undefined && res?.data?.user?.eligible_for_renewal !== null) {
          setEligibleForRenewal(!!res?.data?.user?.eligible_for_renewal)
        } else {
          setEligibleForRenewal(currentRow?.[1]?.status === 0)
        }
      })
      .finally(() => {
        setLoadingGrid(false)
      })
  }, [currentRow?.length])

  const onCloseForm = () => {
    dispatch(fetchUpdateApiData())
    if (!addDataDetail?.isAddNew) {
      dispatch(clearCurrentRowData())
      dispatch(clearParentTableData())
    }
    setAddGridDataDetail({ open: false })
  }

  const onSubmit = () => {
    setSubmitting(true)
    const payload = {
      booking_reservation_id: currentRow?.[1]?.booking_reservation_id,
      user: userData,
      item_date_time_id: currentRow?.[0]?.id,
      id: currentRow?.[1]?.id,
      eligible_for_renewal: eligibleForRenewal ? 1 : 0,
    }
    request('update-renewal-data', 'POST', payload).then((res) => {
      isSuccessResponse(res, 'Form submitted successfully!')
      setSubmitting(false)
      onCloseForm()
    })
  }
  if (loadingGrid) {
    return (
      <div className='p-5 d-flex flex-column align-items-center justify-content-center' style={{ minHeight: '16rem' }}>
        <Loader type='ball-pulse' color={primary_color} />
      </div>
    )
  }

  return (
    <div className='p-5'>
      <Button color='dark' onClick={onCloseForm} className='mb-4'>
        {' '}
        <i class='fa-sharp fa-solid fa-arrow-left'></i>
      </Button>
      <AvForm>
        <div className='mb-4'>
          <div className='body1 mb-4 font-weight-bold' style={{ color: primary_color }}>
            Edit User
          </div>
          <Row>
            <Col md={6}>
              <label className='subtitle1'>First Name</label>
              <AvField
                type='text'
                name='first_name'
                className='subtitle1'
                value={userData?.first_name}
                onChange={(e) => {
                  setUserData({
                    ...userData,
                    first_name: e.target.value,
                  })
                }}></AvField>
              <label className='subtitle1'>Email</label>
              <AvField
                type='email'
                name='email'
                className='subtitle1'
                value={userData?.email}
                onChange={(e) => {
                  setUserData({
                    ...userData,
                    email: e.target.value,
                  })
                }}></AvField>
            </Col>
            <Col md={6}>
              <label className='subtitle1'>Surname</label>
              <AvField
                type='text'
                name='surname'
                className='subtitle1'
                value={userData?.surname}
                onChange={(e) => {
                  setUserData({
                    ...userData,
                    surname: e.target.value,
                  })
                }}></AvField>
              <label className='subtitle1'>Phone Number</label>
              <AvField
                type='text'
                name='phone_no'
                className='subtitle1'
                value={userData?.phone_no}
                onChange={(e) => {
                  setUserData({
                    ...userData,
                    phone_no: e.target.value,
                  })
                }}></AvField>
            </Col>
            <Col md={12} className='mt-2'>
              <div className='form-check mb-2'>
                <input
                  id='renewal-subscription'
                  className='form-check-input'
                  type='checkbox'
                  checked={!!userData?.subscription}
                  onChange={(e) => {
                    setUserData({
                      ...userData,
                      subscription: e.target.checked,
                    })
                  }}
                />
                <label
                  htmlFor='renewal-subscription'
                  style={{ textTransform: 'none', fontWeight: '400' }}
                  className='form-check-label subtitle1'>
                  I would like to receive future communications from Secure Lockers.
                </label>
              </div>
              <div className='form-check'>
                <input
                  id='renewal-rebook'
                  className='form-check-input'
                  checked={!!userData?.rebook}
                  onChange={(e) => {
                    setUserData({
                      ...userData,
                      rebook: e.target.checked,
                    })
                  }}
                  type='checkbox'
                />
                <label htmlFor='renewal-rebook' style={{ textTransform: 'none', fontWeight: '400' }} className='form-check-label subtitle1'>
                  I would like to book this locker again.
                </label>
              </div>
            </Col>
          </Row>
        </div>
        <hr></hr>
        <div className='my-4'>
          <div className='body1 mb-4 font-weight-bold' style={{ color: primary_color }}>
            Edit Bookings
          </div>
          <BookingTable data={bookingData} />
          <div className='form-check d-flex align-items-center'>
            <input
              id='eligible-for-renewal'
              className='form-check-input'
              type='checkbox'
              style={{ transform: 'scale(1.3)' }}
              checked={eligibleForRenewal}
              onChange={(e) => {
                setEligibleForRenewal(e.target.checked)
              }}
            />
            <label htmlFor='eligible-for-renewal' style={{ textTransform: 'none', fontWeight: '400' }} className='form-check-label ml-3 subtitle1'>
              Eligible for renewal
            </label>
          </div>
        </div>
        <hr></hr>
        <div className='my-4'>
          <div className='body1 mb-4 font-weight-bold' style={{ color: primary_color }}>
            Edit {userData?.domain_name}
          </div>

          <div>
            <AvRadioGroup
              name={'rebookable'}
              value={userData?.rebookable !== undefined && userData?.rebookable !== null ? String(userData?.rebookable) : ''}
              onChange={(e) => {
                setUserData({
                  ...userData,
                  rebookable: parseInt(e.target.value, 10),
                })
              }}>
              {[
                { title: 'Allow users to rebook a locker', value: '1' },
                { title: 'Do not allow users to rebook a locker next year', value: '0' },
              ]?.map((item, key) => (
                <>
                  <AvRadio value={item?.value} label={<span className='subtitle1'>{item?.title}</span>} className='subtitle1' />
                </>
              ))}
            </AvRadioGroup>
          </div>
        </div>
        <div className='d-flex justify-content-end mt-5'>
          {' '}
          <button
            className='btn rounded-pill mt-2 text-danger border-danger mr-3'
            type='button'
            id='close-btn'
            onClick={(e) => {
              onCloseForm()
              e.preventDefault()
              e.stopPropagation()
            }}
            style={{ fontWeight: 700, width: '12rem' }}>
            Close
          </button>
          <button
            className='btn text-white rounded-pill mt-2 mr-3'
            disabled={!!submitting}
            type='submit'
            id='save-button'
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              onSubmit()
            }}
            style={{ background: primary_color, fontWeight: 700, width: '14rem' }}>
            {submitting ? 'Saving...' : 'Save'}
          </button>
        </div>
      </AvForm>
    </div>
  )
}

const BookingTable = ({ data }) => {
  return (
    <div className='table-responsive'>
      <table className='table table-bordered' style={{ borderColor: '#EAEAEA' }}>
        <thead>
          <tr>
            <th style={{ color: primary_color }} className='subtitle1 font-weight-bold'>
              Booking ID
            </th>
            <th style={{ color: primary_color }} className='subtitle1 font-weight-bold'>
              First Name
            </th>
            <th style={{ color: primary_color }} className='subtitle1 font-weight-bold'>
              Surname
            </th>
            <th style={{ color: primary_color }} className='subtitle1 font-weight-bold'>
              Year Group
            </th>
            <th style={{ color: primary_color }} className='subtitle1 font-weight-bold'>
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              <td style={{ borderColor: '#EAEAEA' }} className='subtitle1'>
                {row?.booking_id}
              </td>
              <td style={{ borderColor: '#EAEAEA' }} className='subtitle1'>
                {row?.first_name}
              </td>
              <td style={{ borderColor: '#EAEAEA' }} className='subtitle1'>
                {row?.surname}
              </td>
              <td style={{ borderColor: '#EAEAEA' }} className='subtitle1'>
                {row?.year_group}
              </td>
              <td style={{ borderColor: '#EAEAEA' }} className='subtitle1'>
                {row?.status}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default UpdateRenewalStudent
